export default IconCurrencyShekel => `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-currency-shekel" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
  <path d="M6 18v-12h4a4 4 0 0 1 4 4v4" />
  <path d="M18 6v12h-4a4 4 0 0 1 -4 -4v-4" />
</svg>`;